import { render } from "react-dom";
import { useState, useEffect, useCallback } from "react";
import { Card } from "./components/card";
import { ScaleWrapper } from "./components/scale-wrapper";
import { useGlobalStyles } from "./styled/reset";
import { themeGlobal, themes } from "./styled/theme";
import { useBoardType } from "./hooks/board.hook";
import { useWakeLock } from "./hooks/wakelock.hook";

const App = () => {
  useGlobalStyles();
  themeGlobal();
  useWakeLock();
  const { boardType } = useBoardType();
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Apply theme changes
  useEffect(() => {
    document.body.className = themes[boardType];
  }, [boardType]);

  // Listen for fullscreen change events (e.g. user presses Escape)
  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  const toggleFullscreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.warn("Fullscreen request failed:", err);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.warn("Exit fullscreen failed:", err);
      });
    }
  }, []);

  return (
    <ScaleWrapper enabled={isFullscreen}>
      <Card
        onToggleFullscreen={toggleFullscreen}
        isFullscreen={isFullscreen}
      />
    </ScaleWrapper>
  );
};

render(<App />, document.getElementById("root"));
